import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { NotificationBell } from '../components/notifications/NotificationBell';

export const ClientLayout = () => {
  const { logout } = useAuth();
  return (
    <div className="foundation-shell">
      <aside className="fixed inset-y-0 left-0 w-64 bg-[#000080] p-6 text-white">
        <Link to="/client/dashboard" className="text-xl font-black">AeroBott Client</Link>
        <nav className="mt-8 grid gap-3 text-sm font-bold">
          <Link to="/client/dashboard">Dashboard</Link>
          <Link to="/client/jobs">My jobs</Link>
          <Link to="/client/jobs/new">Post new job</Link>
          <Link to="/client/payments">Payments</Link>
          <Link to="/client/messages">Messages</Link>
          <Link to="/support/tickets" className="hover:text-[#FF9933]">Support tickets</Link>
          <Link to="/disputes" className="hover:text-[#FF9933]">My disputes</Link>
        </nav>
        <button onClick={() => void logout()} className="mt-8 rounded-xl bg-[#FF9933] px-3 py-2 text-sm font-black text-slate-950">Log out</button>
      </aside>
      <main className="ml-64 min-h-screen">
        <header className="flex items-center justify-end gap-3 border-b border-slate-200 bg-white px-8 py-3">
          <NotificationBell />
        </header>
        <div className="p-8"><Outlet /></div>
      </main>
    </div>
  );
};
